<template>
  <div>
      <div class="row mt-4">
          <div class="col">
              <div class="form-group row">
                  <label for="note" class="col-sm-2 col-form-label">Note</label>
                  <div class="col-sm-8">
                      <textarea rows="4" v-model.trim="note" type="text" name="note" class="form-control" />
                  </div>
              </div>
          </div><!--col-->
      </div><!--row-->
      <div class="row">
          <label for="note" class="col-sm-2 col-form-label"></label>
          <div class="col-sm-8">
            <b-button type="submit" size="sm" @click.stop.prevent="handleSubmit" variant="primary"><i class="fa fa-dot-circle-o"></i> Create</b-button>
          </div>
      </div>
    <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>

<script>
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'CreateNote',
  props: {
    noteableType: {
      type: String,
      default: undefined
    },
    noteableId: {
      type: Number,
      default: undefined
    },
    callback: {
      type: Function,
    }
  },
  components: {
    loadingPanel
  },
  data () {
    return {
      note:'',
      showLoadingPanel: false,
    }
  },
  methods: {
    handleSubmit () {
      if (this.noteableId && this.noteableType) {
        // create supplier
        this.showLoadingPanel = true
        this.axios.post('/note', {
            note_type_id: 1,
            noteable_id: this.noteableId,
            noteable_type: this.noteableType,
            note: this.note,
        }).then(response => {
          this.showLoadingPanel = false
          if(response.status === "success"){
            if(this.callback) {
                this.callback();
                this.note = "";
            }
          }
        }).catch(error => {
          this.showLoadingPanel = false
          console.log(error)
        })
      }
    },
  }
}
</script>